import { useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const HEARTBEAT_INTERVAL_MS = 60_000; // 60s — backend's online window is 5min so this is plenty

/**
 * Pings POST /api/me/heartbeat every 60s while the tab is visible & the user
 * is authenticated. Used to drive the "Online now" green dot on Discovery.
 */
export default function useHeartbeat() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return undefined;
    let alive = true;
    const tick = () => {
      if (!alive || document.visibilityState !== "visible") return;
      api.post("/me/heartbeat").catch(() => {});
    };
    tick();
    const id = setInterval(tick, HEARTBEAT_INTERVAL_MS);
    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [user]);
}
